<template>
  <section class="coverage-section py-16">
    <v-container>
      <div class="text-center mb-12">
        <v-chip
          color="primary"
          variant="flat"
          size="small"
          class="font-weight-bold mb-3 px-4"
        >
          COBERTURA REGIONAL
        </v-chip>

        <h2 class="section-title mb-4">
          Líderes en el <span class="text-primary">norte de Cundinamarca</span>
        </h2>

        <p class="section-subtitle mx-auto text-grey-darken-1">
          Nuestra presencia consolidada en los municipios más dinámicos del norte de Cundinamarca nos permite comercializar 
          y gestionar la venta y arriendo de sus predios con total cercanía, conocimiento zonal y agilidad.
        </p>
      </div>

      <!-- Regional Pills Grid with SEO Links -->
      <v-row class="justify-center">
        <v-col
          v-for="(municipality, idx) in municipalities"
          :key="idx"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <router-link
            :to="`/propiedades/${municipality.slug}`"
            class="muni-card pa-6 text-center d-flex flex-column align-center justify-center text-decoration-none"
            :class="{ 'featured-card': municipality.featured }"
            :title="`Ver inmuebles y propiedades en ${municipality.name}, Cundinamarca`"
            :aria-label="`Explorar propiedades en ${municipality.name}`"
          >
            <div class="muni-icon mb-3">
              <v-icon
                :color="municipality.featured ? 'white' : 'primary'"
                size="32"
              >
                {{ municipality.icon }}
              </v-icon>
            </div>

            <div
              class="muni-name text-h6 font-weight-bold mb-1"
              :class="municipality.featured ? 'text-white' : 'text-grey-darken-4'"
            >
              {{ municipality.name }}
            </div>

            <v-chip
              size="x-small"
              :color="municipality.featured ? 'white' : 'primary'"
              :variant="municipality.featured ? 'flat' : 'tonal'"
              class="font-weight-bold mt-2"
            >
              {{ municipality.badge }}
            </v-chip>

            <!-- Call To Action Link Pill -->
            <div
              class="muni-cta mt-3 d-inline-flex align-center font-weight-bold text-caption"
              :class="municipality.featured ? 'text-white' : 'text-primary'"
            >
              <span>Ver inmuebles</span>
              <v-icon size="14" class="muni-cta-arrow ml-1">mdi-arrow-right</v-icon>
            </div>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { slugifyCity } from '@/data/properties';

export default {
  name: 'CoverageSection',
  data() {
    return {
      municipalities: [
        {
          name: 'Gachancipá',
          slug: 'gachancipa',
          badge: 'SEDE PRINCIPAL',
          icon: 'mdi-star-circle',
          featured: true,
        },
        {
          name: 'Zipaquirá',
          slug: 'zipaquira',
          badge: 'COBERTURA INTEGRAL',
          icon: 'mdi-domain',
          featured: false,
        },
        {
          name: 'Sopó',
          slug: 'sopo',
          badge: 'COBERTURA INTEGRAL',
          icon: 'mdi-home-city',
          featured: false,
        },
        {
          name: 'Tocancipá',
          slug: 'tocancipa',
          badge: 'COBERTURA INTEGRAL',
          icon: 'mdi-office-building',
          featured: false,
        },
        {
          name: 'Suesca',
          slug: 'suesca',
          badge: 'COBERTURA INTEGRAL',
          icon: 'mdi-tree',
          featured: false,
        },
        {
          name: 'Sesquilé',
          slug: 'sesquile',
          badge: 'COBERTURA INTEGRAL',
          icon: 'mdi-map-marker-radius',
          featured: false,
        },
        {
          name: 'Guatavita',
          slug: 'guatavita',
          badge: 'COBERTURA INTEGRAL',
          icon: 'mdi-compass-outline',
          featured: false,
        },
      ].map((item) => ({
        ...item,
        slug: item.slug || slugifyCity(item.name),
      })),
    };
  },
};
</script>

<style scoped>
.coverage-section {
  background: linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);
}

.section-title {
  font-size: clamp(1.8rem, 3.5vw, 2.6rem);
  font-weight: 900;
  line-height: 1.2;
  color: #1a1a1a;
}

.section-subtitle {
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 680px;
}

.muni-card {
  display: flex;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  min-height: 205px;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.muni-card:focus-visible {
  outline: 3px solid #A90707;
  outline-offset: 3px;
}

.muni-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
  border-color: rgba(169, 7, 7, 0.35);
}

.featured-card {
  background: #A90707 !important;
  border-color: #A90707 !important;
  box-shadow: 0 15px 35px rgba(169, 7, 7, 0.25);
}

.featured-card:hover {
  box-shadow: 0 20px 45px rgba(169, 7, 7, 0.4);
}

.muni-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(169, 7, 7, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.muni-card:hover .muni-icon {
  transform: scale(1.08);
}

.featured-card .muni-icon {
  background: rgba(255, 255, 255, 0.2);
}

.muni-cta {
  opacity: 0.9;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.muni-cta-arrow {
  transition: transform 0.25s ease;
}

.muni-card:hover .muni-cta {
  opacity: 1;
}

.muni-card:hover .muni-cta-arrow {
  transform: translateX(4px);
}
</style>
